import { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { infos } from "./api";
import { ApiInfos } from "./api/types";

export const infoKeys = {
    all: ["infos"],
};

export const useApiInfos = <TData = ApiInfos>(options?: UseQueryOptions<ApiInfos, AxiosError, TData>) => {
    return useQuery<ApiInfos, AxiosError, TData>(options?.queryKey ?? infoKeys.all, infos, options);
};
